import { CanDeactivateFn } from '@angular/router';
// Type-only, so the lazily loaded page stays out of the routes bundle.
import type { MembersAreaProfileComponent } from '@app/users-area/ui/members-area-profile/members-area-profile.component';

// Asks before leaving the profile with unsaved changes; the page decides whether to save, discard or stay.
export const membersAreaProfileLeaveGuard: CanDeactivateFn<MembersAreaProfileComponent> = component =>
  component.confirmLeave$();
